export interface IDataAttributeExtensionAttribute {
    propertyName: string;
    friendlyName: string;
    propertyTypeDenom: string;
}

export class DataAttribute implements IDataAttributeExtensionAttribute {
    public extensionPropertyName: string = null;

    static compareByPropertyName(a: DataAttribute, b: DataAttribute): number {
        return (a.friendlyName || a.propertyName || '').toLocaleLowerCase().localeCompare((b.friendlyName || b.propertyName || '').toLocaleLowerCase());
    }

    constructor(
        public propertyName: string = '',
        public friendlyName: string = '',
        public domain: string = '',
        public entityTypeDenom: string = '',
        public propertyTypeDenom: string = '',
        public ownerRef: number = null,
        public order: number = 10000,
        public required: boolean = false,
        public isAllowedForSearch: boolean = false,
        public isMostUsedInSearch: boolean = false,
        public isExtensionField: boolean = false,
        public hint: string = '',
        public filterable: boolean = true,
        public isDeniedNotAllowedForFilterRules = false
    ) { }
}

export class GroupedDataAttribute {
    [key: string]: DataAttribute[];
}

export const EduToneExtensionFields = ['metadata'];
export const EduToneExtensionTitleSufix = ' Extension';
export const EduToneExtensionSufix = '.extension';
export const OneRosterExtensionFields = ['metadata', 'userIds'];
export const OneRosterExtensionTitleSufix = ' Extension';
export const OneRosterExtensionSufix = '.extension';
export const SchoolIdPropertyNames = <string[]>['schoolId', 'studentEnrollment.schoolId', 'primaryAssignment.schoolId'];
export const SectionIdPropertyNames = <string[]>['rosterId'];
export const GroupIdPropertyNames = <string[]>['groupId'];
